export const SiteSeperator = () => {
    return "**"
}
export const SiteType = {
    yandex : 'Yandex',
    google : 'Google'
}